import React from 'react';
import '../styles/styles.scss';
import '../styles/custom.css';

class Pagination extends React.Component {
  state = {
    page: 1,
  }

  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
        <div className="list-paginator-container">
          <ul className="paginator-list">
          {
            (() => {
              if(this.props.pagination.prev) {
                return (
                  <li className="paginator-list-item">
                    <a className="paginator-arrow paginator-arrow-left" onClick={(e) => { e.preventDefault(); this.props.paginatePrev() }} href={this.props.pagination.prev}></a>
                  </li>
                )
              }
            })()
          }
          {
            this.props.pagination.links.map((link, i) => 
              <li className={"paginator-list-item" + (link.page == this.props.pagination.page ? ' active': '')} key={i}>
                <a onClick={(e) => { e.preventDefault(); this.props.paginate(link.page) }} href={ link.href }>{ link.page }</a>
              </li>
            )
          }
          {
            (() => {
              if(this.props.pagination.next) {
                return (
                  <li className="paginator-list-item">
                    <a className="paginator-arrow paginator-arrow-right" onClick={(e) => { e.preventDefault(); this.props.paginateNext() }} href={this.props.pagination.next}></a>
                  </li>
                )
              }
            })()
          }
          </ul>
        </div>
      </>
    )
  }
}

export default Pagination;